//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const WorkflowSettingsInModal: FeatureFlag = {"Id":"WorkflowSettingsInModal","Label":"Workflow - open settings in modal","Impact":"Open the settings pane into a modal instead to the side","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
